import { Component, Input, OnInit, AfterViewInit, ElementRef, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { FileSpecsService, FileSpec } from '../../../core/services/file-specs.service';
import { ColumnSpecsService, ColumnSpec } from '../../../core/services/columnSpecs.service';

declare global {
  interface Window {
    bootstrap: any;
  }
}

@Component({
  selector: 'hbo-field-info-icon',
  templateUrl: './field-info-icon.component.html',
  styleUrls: ['./field-info-icon.component.scss']
})
export class FieldInfoIconComponent implements OnInit, AfterViewInit, OnDestroy {
  private tooltipInstance: any = null;
  private langChangeSub?: Subscription;
  iconColor = '#6c757d';

  @Input() fieldName?: string;
  @Input() columnName?: string;
  @Input() iconClass: string = 'bi bi-question-circle ms-2';

  fileSpec?: FileSpec;
  columnSpec?: ColumnSpec;

  constructor(
    private fileSpecsService: FileSpecsService,
    private columnSpecsService: ColumnSpecsService,
    private translateService: TranslateService,
    private el: ElementRef
  ) { }

  get hasSpec(): boolean {
    return !!this.getTooltipHtml();
  }

  ngOnInit(): void {
    if (this.fieldName) {
      this.fileSpec = this.fileSpecsService.getSpec(this.fieldName);
    }
    if (this.columnName) {
      this.columnSpec = this.columnSpecsService.getSpec(this.columnName);
    }
  }

  ngAfterViewInit(): void {
    this.initTooltip();

    this.langChangeSub = this.translateService.onLangChange.subscribe(() => {
      this.initTooltip();
    });
  }

  private initTooltip(): void {
    const icon: HTMLElement | null = this.el.nativeElement.querySelector('i[data-bs-toggle="tooltip"]');
    const html = this.getTooltipHtml();
    if (icon && window['bootstrap'] && html) {
      if (this.tooltipInstance) {
        this.tooltipInstance.dispose();
      }
      this.tooltipInstance = new window['bootstrap'].Tooltip(icon, {
        customClass: 'field-info-custom-tooltip'
      });
    }
  }

  ngOnDestroy(): void {
    if (this.tooltipInstance) {
      this.tooltipInstance.dispose();
      this.tooltipInstance = null;
    }
    this.langChangeSub?.unsubscribe();
  }

  onMouseEnter() {
    this.iconColor = '#495057';
  }

  onMouseLeave() {
    this.iconColor = '#868b8fff';
  }

  getTooltipHtml(): string {
    if (this.columnSpec) {
      const raw = this.translateService.instant(this.columnSpec.tooltipKey);
      const text = typeof raw === 'string' ? raw : this.columnSpec.tooltipKey;
      const layout = this.columnSpec.nowrap === false
        ? 'white-space: normal; max-width: 320px;'
        : 'white-space: nowrap;';
      return `<div style="font-size: 12px; ${layout}">${text}</div>`;
    }

    if (this.fileSpec) {
      const formatList = Array.isArray(this.fileSpec.formats) ? this.fileSpec.formats.join(', ') : '';
      const maxSize = this.fileSpec.maxSize
        ? `${this.fileSpec.maxSize.value} ${this.fileSpec.maxSize.unit}`
        : '';
      const resolution = this.fileSpec.resolution ?? '';

      return `<div style="font-size: 12px;"><div style="white-space: nowrap;"><strong>Format:</strong> ${formatList}</div><div style="white-space: nowrap;"><strong>Max size:</strong> ${maxSize}</div><div style="white-space: nowrap;"><strong>Res:</strong> ${resolution}</div></div>`;
    }

    return '';
  }
}
